import { render, staticRenderFns } from "./SiteNotice.vue?vue&type=template&id=c1130f94&scoped=true"
import script from "./SiteNotice.vue?vue&type=script&lang=js"
export * from "./SiteNotice.vue?vue&type=script&lang=js"
import style0 from "./SiteNotice.vue?vue&type=style&index=0&id=c1130f94&prod&lang=scss"
import style1 from "./SiteNotice.vue?vue&type=style&index=1&id=c1130f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1130f94",
  null
  
)

export default component.exports